import OrderSort from "@/scenes/OrderManagement/enum/OrderSort";

export const OrderSortNameMap = {
    [OrderSort.ORDER_TIME_DESC]: "按下单时间，后下单在前",

    [OrderSort.ORDER_TIME_ASC]: "按下单时间，先下单在前",

    [OrderSort.IMPORT]: "按导入顺序，后导入在前",

    [OrderSort.PAY_TIME_ASC]: "按付款时间，先付款在前",

    [OrderSort.PAY_TIME_DESC]: "按付款时间，后付款在前",

    [OrderSort.ORDER_ITEMS]: "相同商品排一起",

    [OrderSort.PRODUCT_SKU_COLOR_SIZE]: "按颜色尺码排序",

    [OrderSort.BUYER_NICKNAME]: "相同买家昵称排一起",

    [OrderSort.PAYMENT_AMOUNT_DESC]: "按实付金额，金额大在前",

    [OrderSort.SHIP_TIME_ASC]: "按发货时间，先发货在前",

    [OrderSort.SHIP_TIME_DESC]: "按发货时间，后发货在前",

    [OrderSort.SEQUENCE_NO]: "按打印流水号，数字小在前",

    [OrderSort.LAST_SHIPPING_TIME_ASC]: "按最后发货时间，最先逾期在前",

    [OrderSort.PROMISE_SHIPPING_TIME_ASC]: "承诺发货时间最早在前",

    [OrderSort.ORDER_ITEM_QUANTITY]: "按商品数量：数量小在前",

    [OrderSort.ORDER_ITEM_QUANTITY_DESC]: "按商品数量：数量大在前",

    [OrderSort.ORDER_WEIGHT]: "按订单重量：重量小在前",

    [OrderSort.ORDER_CONSIGNEE_REGION]: "按省市区排序",

    [OrderSort.SIMPLE_TITLE_OTHERWISE_SKU_PROPERTIES]: "按规格简称/规格名称排序",

    [OrderSort.PRODUCT_SKU_EXTERNAL_ID]: "按商品编码排序",

    [OrderSort.SKU_EXTERNAL_ID]: "按规格编码排序",

    [OrderSort.ABNORMAL_RECORD_TIME_DESC]: "按异常生成时间降序排序",

    [OrderSort.ABNORMAL_RECORD_TIME_ASC]: "按异常生成时间升序排序",
};

export interface OrderSortTipInfo {
    rule: string;
    eg: string;
    for: string;
}

export const OrderSortTipMap: Record<OrderSort, OrderSortTipInfo | undefined> = {
    [OrderSort.ORDER_TIME_DESC]: {
        rule: "按照订单的下单时间排序",
        eg: "订单A下单时间为今天8点，订单B下单时间为今天10点，则订单B排在前面",
        for: "需要优先对最新下单的订单进行打单发货或者其他操作，推荐使用此排序",
    },
    [OrderSort.ORDER_TIME_ASC]: {
        rule: "按照订单的下单时间排序",
        eg: "订单A下单时间为今天8点，订单B下单时间为今天10点，则订单A排在前面",
        for: "需要优先对最先下单的订单进行打单发货或者其他操作，推荐使用此排序",
    },
    [OrderSort.IMPORT]: {
        rule: "按照订单的导入时间排序",
        eg: "订单A导入时间为今天8点，订单B导入时间为今天10点，则订单B排在前面",
        for: "需要优先对最新导入的订单进行打单发货或者其他操作，推荐使用此排序",
    },
    [OrderSort.PAY_TIME_ASC]: {
        rule: "按照订单的付款时间排序",
        eg: "订单A付款时间为今天8点，订单B付款时间为今天10点，则订单A排在前面",
        for: "需要优先对最先付款的订单进行打单发货或者其他操作，推荐使用此排序",
    },
    [OrderSort.PAY_TIME_DESC]: {
        rule: "按照订单的付款时间排序",
        eg: "订单A付款时间为今天8点，订单B付款时间为今天10点，则订单B排在前面",
        for: "需要优先对最新付款的订单进行打单发货或者其他操作，推荐使用此排序",
    },
    [OrderSort.PRODUCT_SKU_COLOR_SIZE]: {
        rule: "先将订单中商品ID相同的排在一起，再按颜色排序，相同颜色的再按尺码从小到大（如SML）排序。",
        eg:
            "1. 订单A、B、C的商品ID为111，订单D的商品ID为222，则订单A、B、C排在一起\n2. 然后订单A、B的商品颜色为红色，订单C的商品颜色为黄色，则订单A、B排在一起\n3. 最后订单A的商品尺码为S码，订单B的商品尺码为M码，选择了“从小到大”\n",
        for: "适用于服饰类目，希望订单按颜色、尺码排序，便于进行拣货，推荐使用此排序。",
    },
    [OrderSort.ORDER_ITEMS]: {
        rule:
            "将店铺内相同商品排在一起，商品级别是优先按商品编码排序，其次是商品ID，最后是相近的商品标题；sku级别是优先排序相同sku属性，其次是sku编码，最后是skuID",
        eg:
            "订单A包含的黑色裙子S码(商品编码234，skuID是666)；订单B包含的蓝色裙子S码(商品编码是234，skuID是777)；订单C包含的红色裙子M码(商品编码是234，skuID是666)，；订单D包含的蓝色衬衫M码(商品编码是3456，skuID是666)则订单A排在最前面，接下来是订单C，然后是订单B，最后是订单D",
        for: "希望对相同商品、相同规格的订单统一处理，推荐使用此排序",
    },
    [OrderSort.PAYMENT_AMOUNT_DESC]: {
        rule: "按照订单中的实收金额从大到小排序。",
        eg: "订单A实付金额为20元，订单B实付金额为60元。则订单B排在前面。",
        for: "希望按订单金额由大到小顺序处理订单，或者希望相同金额的订单统一处理的，推荐使用此排序。",
    },
    [OrderSort.SHIP_TIME_ASC]: {
        rule: "按照订单的发货时间排序",
        eg: "订单A发货时间为今天8点，订单B发货时间为今天10点，则订单A排在前面",
        for: "需要优先对最先发货的订单进行打单发货或者其他操作，推荐使用此排序",
    },
    [OrderSort.SHIP_TIME_DESC]: {
        rule: "按照订单的发货时间排序",
        eg: "订单A发货时间为今天8点，订单B付发货时间为今天10点，则订单B排在前面",
        for: "需要优先对最新发货的订单进行打单发货或者其他操作，推荐使用此排序",
    },
    [OrderSort.SEQUENCE_NO]: {
        rule: "按照订单中的打印流水号从小到大排序",
        eg: "订单A流水号为1，订单B流水号为2。则订单A排在前面。",
        for: "希望按订单打印流水号从小到大顺序处理订单，推荐使用此排序。",
    },
    [OrderSort.LAST_SHIPPING_TIME_ASC]: {
        rule: "按照订单的最后发货时间排序，最后发货时间越早的排在越前面",
        eg: "订单A最后发货时间为为今天8点，订单B最后发货时间为明天10点，则订单A排在前面",
        for: "需要优先处理快发货逾期的订单，推荐使用此排序",
    },
    [OrderSort.PROMISE_SHIPPING_TIME_ASC]: {
        rule: "按照订单的承诺发货时间排序，承诺发货时间越早的排在越前面",
        eg: "订单A承诺发货时间为为今天8点，订单B承诺发货时间为明天10点，则订单A排在前面",
        for: "需要优先处理快发货逾期的订单，推荐使用此排序",
    },
    [OrderSort.BUYER_NICKNAME]: {
        rule: "按照买家昵称排序",
        eg: "订单A的买家昵称是李白，订单B买家昵称是虞姬，订单C买家昵称是李白，则订单A和C排在一起，再排订单B",
        for: "希望可以查看相同买家的全部订单，推荐使用此排序",
    },
    [OrderSort.ORDER_ITEM_QUANTITY]: {
        rule: "按订单中的商品件数排序。",
        eg: "订单A包含1件商品，订单B包含2件商品。选择了“数量小在前”，则订单A排在前面。",
        for: "希望分别处理单件商品的订单、多件商品的订单，推荐使用此排序。",
    },
    [OrderSort.ORDER_ITEM_QUANTITY_DESC]: {
        rule: "按订单中的商品件数排序。",
        eg: "订单A包含1件商品，订单B包含2件商品。选择了“数量大在前”，则订单B排在前面。",
        for: "希望分别处理单件商品的订单、多件商品的订单，推荐使用此排序。",
    },
    [OrderSort.ORDER_WEIGHT]: {
        rule: "按订单中的商品重量排。没有重量的默认为0(最小值)",
        eg:
            "订单A商品重量为1kg，订单B商品重量为3kg，订单C商品重量为0。选择了“重量小在前”，则订单C排在最前，接下来是订单A，最后是订单B。",
        for: "如果在发货易内设置了商品重量，希望按不同重量去处理订单，推荐使用此排序。",
    },
    [OrderSort.ORDER_CONSIGNEE_REGION]: {
        rule: "订单中的收件省份相同的排在一起，按收货省份搜索下拉框里的省份顺序排序",
        eg: "",
        for: "希望相同省份的订单统一处理，推荐使用此排序。",
    },
    [OrderSort.SIMPLE_TITLE_OTHERWISE_SKU_PROPERTIES]: {
        rule:
            "将订单中按规格简称/规格名称(有简称优先取简称，无简称取规格名称)相同的订单排在一起，规格简称/规格名称为空的排在最后",
        eg:
            "订单A包含商品666-规格1(简称)，订单B包含商品888-规格1(简称)，订单C包含商品666-规格2(简称)，则订单A、B因为规格简称相同排在一起，订单C排在订单A、B的后面",
        for: "不同的商品链接下有相同的规格时，如果希望相同规格的订单统一处理，推荐使用此排序",
    },
    [OrderSort.PRODUCT_SKU_EXTERNAL_ID]: {
        rule:
            "将订单中商品编码相同的排在一起，商品编码为空排最后。相同商品编码的再按规格(SKU)编码排序，规格(SKU)编码为空排最后。",
        eg:
            "订单A包含的商品编码是234，订单B包含的商品编码是345，订单C包含的商品没有编码，则订单A排在最前，接下来是订单B，最后是订单C",
        for: "如果在商家后台创建商品时填写了商品编码，希望统一处理商品编码相同的订单，推荐使用此排序",
    },
    [OrderSort.SKU_EXTERNAL_ID]: {
        rule: "将订单中规格(SKU)编码相同的排在一起，规格(SKU)编码为空的排在最后",
        eg:
            "订单A包含的规格编码是234，订单B包含的规格编码是456，订单C没有规格编码，则订单A排在最前，接下来是订单B，最后是订单C",
        for: "如果在商家后台创建商品时填写了规格编码，希望统一处理规格编码相同的订单，推荐使用此排序。",
    },
    [OrderSort.ABNORMAL_RECORD_TIME_DESC]: undefined,
    [OrderSort.ABNORMAL_RECORD_TIME_ASC]: undefined,
};

export default OrderSortNameMap;
